import { render, staticRenderFns } from "./StopSubmissionSticker.vue?vue&type=template&id=63485c5f&"
import script from "./StopSubmissionSticker.vue?vue&type=script&lang=js&"
export * from "./StopSubmissionSticker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports